import { Checkbox } from "@remo-co/ui-core/src/components/Checkbox";
import { InputLabel } from "@remo-co/ui-core/src/components/InputLabel";
import { List } from "@remo-co/ui-core/src/components/List";
import { ListItem } from "@remo-co/ui-core/src/components/ListItem";
import { ListItemIcon } from "@remo-co/ui-core/src/components/ListItemIcon";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import React, { useState } from "react";
import _ from "lodash";
import moment from "moment";
import "./AddCompanyMember.scss";
import { IEvent } from "modules/event/types";

interface ICheckBoxList {
  allEvents: IEvent[];
  mappedEvents: string[];
  minWidth?: boolean;
  onChange: (events: string[]) => void;
}

const CheckboxList = ({
  allEvents,
  mappedEvents,
  minWidth,
  onChange,
}: ICheckBoxList) => {
  const [selectedEvents, setSelectedEvents] = useState<string[]>(mappedEvents);

  const handleToggle = (event: React.MouseEvent, eventId?: string) => {
    event?.preventDefault();
    const newSelected = [...selectedEvents];
    let currentIndex = null;

    if (eventId) {
      currentIndex = selectedEvents.indexOf(eventId);

      if (currentIndex === -1) {
        newSelected.push(eventId);
      } else {
        newSelected.splice(currentIndex, 1);
      }
      setSelectedEvents(newSelected);
    }
  };

  const isSelected = (id: string) => selectedEvents.indexOf(id) !== -1;

  React.useEffect(() => {
    onChange(selectedEvents);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEvents]);

  return (
    <List className={`checkboxlist ${minWidth ? "minwidth" : ""}`}>
      {_.map(allEvents, (event) => {
        const labelId = `input-label-${event.id}`;
        const checkboxId = `checkbox-list-label-${event.id}`;

        return (
          <ListItem
            key={event.id}
            dense
            button
            onClick={(e) => handleToggle(e, event.id)}
            className="list"
          >
            <ListItemIcon>
              <InputLabel id={labelId}>
                <Checkbox
                  color="primary"
                  edge="start"
                  checked={!!(event.id && isSelected(event.id))}
                  disableRipple
                  inputProps={{ "aria-labelledby": checkboxId }}
                  className={event.id && isSelected(event.id) ? "selected" : ""}
                />
              </InputLabel>
            </ListItemIcon>
            <div className="info">
              <Typography className="title">{event.name}</Typography>
              {minWidth && event.shortDescription ? (
                <Typography className="desc">
                  {event.shortDescription}
                </Typography>
              ) : (
                <Typography className="time">
                  {moment(event.startTime).format("hh:mma MMM. Do ")}
                  {" - "}
                  {moment(event.endTime).format("hh:mma MMM. Do YYYY")}
                </Typography>
              )}
            </div>
          </ListItem>
        );
      })}
    </List>
  );
};

export default CheckboxList;
